import Experience from "./Experience/Experience";

const app = new Experience(document.querySelector(".web-gl"));
